import { BaseAssetShortcode } from './base-asset-shortcode.enum';
import { EthereumAssetShortcode } from './ethereum-asset-shortcode.enum';
import { TronAssetShortcode } from './tron-asset-shortcode.enum';
import { BinanceAssetShortcode } from './binance-asset-shortcode.enum';

export const AssetShortcode = Object.assign(
  {...BaseAssetShortcode},
  {...EthereumAssetShortcode},
  {...TronAssetShortcode},
  {...BinanceAssetShortcode}
);

export type AssetShortcode = BaseAssetShortcode |
  EthereumAssetShortcode |
  TronAssetShortcode |
  BinanceAssetShortcode;

export enum AssetType {
  BaseAsset = 'BASE_ASSET',
  ERC20 = 'ERC20',
  TRC20 = 'TRC20',
  BEP20 = 'BEP20',
}
